{
  "ConferenceParticipation": "Messedeltagelse",
  "EducationalOperations": "Utdanningstilbud",
  "FeasibilityStudy": "Forstudie",
  "InnovationCooperation": "Innovasjonssamarbeid",
  "InnovationCounseling": "Innovasjonsrådgivning",
  "InternationalMarketPositionsDevelopment": "Utvikling av nye eller forsterkede internasjonale markedsposisjoner",
  "InternationalMarketsKnowledge": "Opplæring knyttet til internasjonalisering",
  "Investments": "Investeringer",
  "OperationApplication": "Driftssøknad",
  "Training": "Opplæring"
}
